<template>
  <div class="all">
    <div class="top">
      <div class="left">
        <img @click="gotopage('/', -1)" height="40px"
             src="https://lanxiaoxiao.obs.cn-north-4.myhuaweicloud.com/web/admin/logo/logo_top.svg" alt="logo" />
      </div>
      <div class="right">
        <el-popover
          :width="200"
          placement="bottom-end"
          trigger="hover"
        >
          <template #reference>
            <div class="user-wrap">
              <el-icon class="user-icon"><User /></el-icon>
              <span class="username-text">{{ user?.name || "--" }}</span>
            </div>
          </template>
          <div class="pop-menu">
            <div class="pop-item" @click="loginout()">
              <el-icon><Logout /></el-icon>
              <span>退出登录</span>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="main">
      <div class="left">
        <div class="sidebar-inner">
          <el-menu
            router
            class="side-menu"
            v-loading="menuLoading"
            background-color="#ffffff"
            text-color="#4e5969"
            active-text-color="#409EFF"
          >
            <el-sub-menu
              v-for="(item, index) in tablist"
              :key="index"
              :index="String(item.id)"
              class="parent-menu-group"
            >
              <template #title>
                <el-icon class="parent-icon">
                  <component :is="item.icon || Location" />
                </el-icon>
                <span class="parent-title">{{ item.name }}</span>
              </template>
              <template v-if="Array.isArray(item.list) && item.list.length">
                <el-menu-item
                  v-for="(ite, inde) in item.list"
                  :key="inde"
                  :index="ite.path"
                  class="child-menu-item"
                >
                  <span class="child-dot"></span>
                  <span>{{ ite.name }}</span>
                </el-menu-item>
              </template>
            </el-sub-menu>
          </el-menu>
        </div>
      </div>
      <div class="right">
        <div class="router-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElIcon, User, Logout, Location } from 'element-plus';
import router from '@/router';
import { menulist } from '@/api/api';

const tablist = ref(null);
const tab_index = ref(-1);
const menuLoading = ref(false);

let user = ref(null);
try {
  const userStr = localStorage.getItem('user');
  if (userStr) {
    user.value = JSON.parse(userStr);
  }
} catch (e) {
  user.value = null;
}

const gotopage = (page, index) => {
  if (page) {
    router.push(page);
    tab_index.value = index;
  }
};

const getmenu = async () => {
  menuLoading.value = true;
  try {
    const res = await menulist();
    if (res.code === 200) {
      tablist.value = res.data.list;
    }
  } finally {
    menuLoading.value = false;
  }
};

const loginout = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  router.push('login');
};

onMounted(() => {
  getmenu();
});
</script>

<style lang="scss" scoped>
.all {
  width: 100%;
  height: 100vh;
  min-width: 1000px;
  background-color: #f5f7fa;
  overflow: hidden;

  .top {
    height: 60px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    z-index: 101;
    position: relative;

    .left {
      margin: 0 20px;
      cursor: pointer;
    }

    .right {
      margin-right: 40px;

      .user-wrap {
        display: flex;
        align-items: center;
        gap: 6px;
        cursor: pointer;
        padding: 6px 12px;
        border-radius: 6px;

        &:hover {
          background-color: #f0f2f5;
        }

        .user-icon {
          font-size: 18px;
          color: #4e5969;
        }

        .username-text {
          font-size: 14px;
          color: #1f2329;
          font-weight: 500;
        }
      }
    }
  }

  .main {
    height: calc(100vh - 60px);
    display: flex;

    .left {
      height: 100%;
      width: 220px;
      flex-shrink: 0;
      background: #ffffff;
      box-shadow: 1px 0 4px rgba(0, 0, 0, 0.06);
      overflow-y: auto;
      /* 关键：和顶部header做隔离，不再贴死logo底部 */
      padding-top: 12px;

      ::-webkit-scrollbar {
        width: 4px;
      }
      ::-webkit-scrollbar-thumb {
        background-color: #dcdfe6;
        border-radius: 2px;
      }
      scrollbar-width: thin;

      .sidebar-inner {
        padding: 0 4px;
      }

      .side-menu {
        border-right: none;

        .parent-menu-group {
          margin-bottom: 6px;

          :deep(.el-sub-menu__title) {
            height: 44px;
            line-height: 44px;
            padding-left: 14px !important;
            font-size: 14px;
            font-weight: 500;
            color: #1f2329;

            &:hover {
              background-color: #f7f8fa !important;
            }

            .parent-icon {
              font-size: 18px;
              margin-right: 10px;
              color: #6b7785;
            }
          }
        }

        .child-menu-item {
          :deep(.el-menu-item) {
            height: 40px;
            line-height: 40px;
            padding-left: 46px !important;
            font-size: 13.5px;
            background-color: #f7f8fa;
            border-radius: 0 8px 8px 0;
            margin-right: 8px;
            margin-bottom: 3px;
            color: #4e5969;

            &:hover {
              background-color: #edf1f7 !important;
            }

            &.is-active {
              background-color: #e8f3ff !important;
              color: #409eff !important;
              font-weight: 500;
            }
          }
          .child-dot {
            display: inline-block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #c0c6cf;
            margin-right: 10px;
          }
        }
      }
    }

    .right {
      flex: 1;
      height: 100%;
      overflow-y: auto;

      .router-container {
        padding: 16px;
        min-height: 100%;
      }
    }
  }
}

.pop-menu {
  padding: 4px 0;

  .pop-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 18px;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background-color: #f5f7fa;
      color: #409eff;
    }
  }
}
</style>
